import React from 'react';
import { Gift } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const bonuses = [{
  title: 'Checklist Pre-Rodada 5 Min',
  desc: 'Evitá el 80% de las fallas antes de salir',
  value: '$47'
}, {
  title: 'Guía de Herramientas ARG',
  desc: 'Qué comprar, qué evitar, lista de inventario',
  value: '$37'
}, {
  title: 'Planilla de Mantenimiento',
  desc: 'Sistema por km y calendario de intervenciones',
  value: '$27'
}, {
  title: 'Guía Express de Errores',
  desc: '20 síntomas + árbol de decisión + hoja de emergencia',
  value: '$37'
}, {
  title: 'Kit de Registros Técnicos',
  desc: 'Historial completo + costo por km + hojas printables',
  value: '$47'
}, {
  title: 'Manual de Hábitos',
  desc: '7 días para cambiar los hábitos que destruyen tu rueda',
  value: '$27'
}];
export function Bonuses() {
  return <AnimatedSection className="py-24 relative" data-id="element-16">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-yellow/5 via-brand-dark to-brand-dark -z-10" data-id="element-17" />

      <div className="container mx-auto px-4 md:px-6" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-yellow/20 mb-6" data-id="element-20">
            <Gift className="w-8 h-8 text-brand-yellow" data-id="element-21" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-22">
            🎁 6 BONOS — SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-23">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-24">
            {bonuses.map((bonus, index) => <div key={index} className="flex items-center justify-between bg-brand-surface border border-brand-border rounded-lg p-4 md:p-6" data-id="element-25">
                <div className="flex items-start gap-4" data-id="element-26">
                  <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center shrink-0 mt-1" data-id="element-27">
                    <span className="text-green-500 font-bold text-sm" data-id="element-28">✓</span>
                  </div>
                  <div data-id="element-29">
                    <h4 className="font-bold text-white text-lg" data-id="element-30">
                      {bonus.title}
                    </h4>
                    <p className="text-zinc-400 text-sm" data-id="element-31">{bonus.desc}</p>
                  </div>
                </div>
                <div className="text-right shrink-0 ml-4" data-id="element-32">
                  <div className="text-zinc-500 line-through text-sm" data-id="element-33">
                    {bonus.value}
                  </div>
                  <div className="text-brand-yellow font-bold" data-id="element-34">GRATIS</div>
                </div>
              </div>)}
          </div>

          <div className="text-center bg-brand-surface/80 border border-brand-yellow/30 rounded-xl p-6 inline-block w-full" data-id="element-35">
            <p className="text-xl md:text-2xl font-heading" data-id="element-36">
              Valor total bonos:{' '}
              <span className="line-through text-zinc-500" data-id="element-37">$222</span>{' '}
              <span className="text-brand-yellow font-bold" data-id="element-38">
                → GRATIS con tu Mega Pack ✅
              </span>
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}